import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { Subscription } from 'rxjs';
import { VersionReleaseNotes, VersionUpdateService } from '../services/version-update.service';

@Component({
    selector: 'app-version-update-banner',
    standalone: true,
    imports: [CommonModule, ButtonModule, DialogModule],
    templateUrl: './version-update-banner.component.html',
    styleUrl: './version-update-banner.component.scss'
})
export class VersionUpdateBannerComponent implements OnInit, OnDestroy {
    visible = false;
    latestVersion: string | null = null;
    releaseNotes: VersionReleaseNotes | null = null;

    private subscription: Subscription | null = null;

    constructor(private versionUpdateService: VersionUpdateService) {}

    ngOnInit(): void {
        this.subscription = this.versionUpdateService.updateAvailable$.subscribe((available) => {
            this.visible = available;
            if (available) {
                this.latestVersion = this.versionUpdateService.getLatestServerVersion();
                this.releaseNotes = this.versionUpdateService.getLatestReleaseNotes();
            }
        });
    }

    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
    }

    get notesTitle(): string {
        return this.releaseNotes?.title?.trim() || "What's new in this version";
    }

    get dialogWidth(): string {
        return this.releaseNotes ? '560px' : '480px';
    }

    reload(): void {
        this.versionUpdateService.applyUpdate();
    }

    cancel(): void {
        this.visible = false;
        this.versionUpdateService.dismissBanner();
    }
}
